import { Booking } from "../../types";

interface Props {
  record?: Booking;
  label?: string;
  addLabel?: boolean;
}

const BookingInvoice: React.FC<Props> = (props) => {
  const { record: booking } = props;

  if (!booking) {
    return <></>;
  }

  const bookingInvoices = booking.booking_invoices ?? [];

  if (bookingInvoices.length === 0) {
    const fallback = booking.invoice_number?.trim()
      ? booking.invoice_number
      : "-";
    return <div>{fallback}</div>;
  }

  return (
    <div>
      {bookingInvoices
        .map((invoice) =>
          invoice.invoice_number?.trim()
            ? invoice.invoice_number
            : "-"
        )
        .join(", ")}
    </div>
  );
};
BookingInvoice.defaultProps = {
  label: "Invoice Number",
  addLabel: true,
};

export default BookingInvoice;
